module.exports = __webpack_public_path__ + "img/icon-2-1.fac1fbd1.svg";